module.exports = __webpack_public_path__ + "d935c1353a46c9d143b0296889c1430a.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/sms-settings/sms-settings-ja.html
// module id = 1996
// module chunks = 0